/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';
import { unixNowSeconds } from 'cio/utils/time';

import {
  DEFAULT_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS,
  MIN_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS,
  MAX_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS,
} from 'cio/models/account';
import { next } from '@ember/runloop';
import { action } from '@ember/object';

interface ControlTeamAccessFieldArgs {
  onInput: (value: number) => unknown;
  onBlur?: () => unknown;
  labePrefix?: string;
  value: number;
  errors: string[];
}

export const controlSupportTeamAccessFieldValidation = {
  daysLimit(value: number) {
    if (!/^\d+$/.test(value as unknown as string)) {
      return 'Please enter a valid number.';
    }

    if (value < MIN_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS || value > MAX_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS) {
      return `The number of days must be between ${MIN_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS} and ${MAX_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS} days.`;
    }

    return true;
  },
};

export default class SupportFormControlTeamAccess extends Component<ControlTeamAccessFieldArgs> {
  @service account!: AccountService;

  @tracked initialFieldValue!: number;

  get min() {
    return MIN_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS;
  }

  get max() {
    return MAX_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS;
  }

  constructor(owner: unknown, args: ControlTeamAccessFieldArgs) {
    super(owner, args);

    this.initialFieldValue = this.getInitialFieldValue();
    if (this.initialFieldValue !== this.args.value) {
      next(() => {
        this.args.onInput(this.initialFieldValue);
      });
    }
  }

  getInitialFieldValue() {
    if (!this.account.current.supportTeamAccessEnabled) {
      return this.args.value;
    }

    let secondsFromNow = this.account.current.accessGrantedUntil - unixNowSeconds();
    let daysFromNow = Math.round(secondsFromNow / (24 * 60 * 60));

    return Math.max(daysFromNow, DEFAULT_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS);
  }

  @action
  onInput(value: number) {
    this.initialFieldValue = value;
    this.args.onInput(value);
  }
}
